import cx from 'classnames';
import { useRef, useState } from 'react';
import style from '../../../../FilterPanel.module.scss';
import { SavePresetModal } from '../../../../SavePresetModal';
import { useFilterPanelContext } from '../../../../context/FilterPanelContext';

const SaveFilterPresetButton = () => {
  const { values, activePresetId, setActivePresetId, onPresetCreate } =
    useFilterPanelContext();

  const [presetName, setPresetName] = useState<string>('');
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);

  const saveBtnRef = useRef<HTMLButtonElement>(null);

  const handleButtonClick = () => {
    setShowSaveModal(true);
  };

  const handleSaveFilterPreset = () => {
    let filterCounter = Number(localStorage.getItem('filterCounter') || '0');
    filterCounter += 1;
    localStorage.setItem('filterCounter', filterCounter.toString());
    const newId = Date.now().toString();
    onPresetCreate({ name: presetName, filters: values });
    setActivePresetId(Number(newId));
    setShowSaveModal(false);
  };

  const handleCancelSaveModal = () => {
    setShowSaveModal(false);
  };

  return (
    <>
      <button
        className={cx(style.iconButton, showSaveModal && style.active)}
        onClick={handleButtonClick}
        ref={saveBtnRef}
        title={activePresetId ? 'Обновить фильтр' : 'Сохранить фильтр'}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M19 21L12 17L5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21Z"
            stroke="#35373A"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {showSaveModal && (
        <div
          style={{
            position: 'absolute',
            zIndex: 100,
            left: saveBtnRef.current?.offsetLeft || 0,
            top: (saveBtnRef.current?.offsetTop || 0) + 48,
          }}
        >
          <SavePresetModal
            value={presetName}
            onChange={setPresetName}
            onSave={handleSaveFilterPreset}
            onCancel={handleCancelSaveModal}
            isEdit={false}
          />
        </div>
      )}
    </>
  );
};

export default SaveFilterPresetButton;
